export const encodeBase64RouteValue = (value: string): string => {
    if (typeof value !== "string") {
        return "";
    }

    const normalized = value.trim();
    if (!normalized) {
        return "";
    }

    try {
        return btoa(unescape(encodeURIComponent(normalized)));
    } catch (error) {
        return normalized;
    }
};

export const decodeBase64RouteValue = (value: string | null | undefined): string => {
    if (typeof value !== "string") {
        return "";
    }

    const normalized = value.trim();
    if (!normalized) {
        return "";
    }

    try {
        return decodeURIComponent(escape(atob(normalized))).trim();
    } catch (error) {
        return normalized;
    }
};

// Decimal IDs can themselves be valid base64 (for example "242"). Recognize
// legacy raw IDs before decoding so they cannot select a different record.
export const decodePositiveRouteId = (value: string | null | undefined): number | null => {
    const normalized = typeof value === "string" ? value.trim() : "";
    const decoded = /^\d+$/.test(normalized) ? normalized : decodeBase64RouteValue(normalized);
    if (!/^\d+$/.test(decoded)) {
        return null;
    }
    const id = Number(decoded);
    return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export const decodeAssessmentLicenseId = decodePositiveRouteId;

export const encodeRouteId = (value: number | null | undefined): string | null => {
    return typeof value === "number" && Number.isSafeInteger(value) && value > 0
        ? encodeBase64RouteValue(String(value))
        : null;
};
